import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('..\\store\\index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('..\\store\\cartItems.js'), 'cartItems.js')
  resolveStoreModules(require('..\\store\\currentStore.js'), 'currentStore.js')
  resolveStoreModules(require('..\\store\\customer.js'), 'customer.js')
  resolveStoreModules(require('..\\store\\customerCategory.js'), 'customerCategory.js')
  resolveStoreModules(require('..\\store\\customerCollection.js'), 'customerCollection.js')
  resolveStoreModules(require('..\\store\\customizable-orders.js'), 'customizable-orders.js')
  resolveStoreModules(require('..\\store\\registers.js'), 'registers.js')
  resolveStoreModules(require('..\\store\\settings.js'), 'settings.js')
  resolveStoreModules(require('..\\store\\territorialUnit.js'), 'territorialUnit.js')
  resolveStoreModules(require('..\\store\\userLoginsForPinLogin.js'), 'userLoginsForPinLogin.js')
  resolveStoreModules(require('..\\store\\userProfile.js'), 'userProfile.js')
  resolveStoreModules(require('..\\store\\users.js'), 'users.js')
  resolveStoreModules(require('..\\store\\admin-settings\\globalSettings.js'), 'admin-settings/globalSettings.js')
  resolveStoreModules(require('..\\store\\admin-settings\\moduleFields.js'), 'admin-settings/moduleFields.js')
  resolveStoreModules(require('..\\store\\admin-settings\\modules.js'), 'admin-settings/modules.js')
  resolveStoreModules(require('..\\store\\appraisals\\appraisals.js'), 'appraisals/appraisals.js')
  resolveStoreModules(require('..\\store\\catalog\\catalog.js'), 'catalog/catalog.js')
  resolveStoreModules(require('..\\store\\catalog\\item.js'), 'catalog/item.js')
  resolveStoreModules(require('..\\store\\catalog\\product.js'), 'catalog/product.js')
  resolveStoreModules(require('..\\store\\catalog\\transfer.js'), 'catalog/transfer.js')
  resolveStoreModules(require('..\\store\\catalog\\wishlist.js'), 'catalog/wishlist.js')
  resolveStoreModules(require('..\\store\\cms\\assets.js'), 'cms/assets.js')
  resolveStoreModules(require('..\\store\\cms\\components.js'), 'cms/components.js')
  resolveStoreModules(require('..\\store\\cms\\contents.js'), 'cms/contents.js')
  resolveStoreModules(require('..\\store\\cms\\datasources.js'), 'cms/datasources.js')
  resolveStoreModules(require('..\\store\\cms\\fields.js'), 'cms/fields.js')
  resolveStoreModules(require('..\\store\\common\\currencies.js'), 'common/currencies.js')
  resolveStoreModules(require('..\\store\\common\\customAttribute.js'), 'common/customAttribute.js')
  resolveStoreModules(require('..\\store\\common\\email.js'), 'common/email.js')
  resolveStoreModules(require('..\\store\\common\\entityStatus.js'), 'common/entityStatus.js')
  resolveStoreModules(require('..\\store\\common\\file.js'), 'common/file.js')
  resolveStoreModules(require('..\\store\\common\\formatter.js'), 'common/formatter.js')
  resolveStoreModules(require('..\\store\\common\\gridSetting.js'), 'common/gridSetting.js')
  resolveStoreModules(require('..\\store\\common\\itemGroup.js'), 'common/itemGroup.js')
  resolveStoreModules(require('..\\store\\common\\itemType.js'), 'common/itemType.js')
  resolveStoreModules(require('..\\store\\common\\jobPriority.js'), 'common/jobPriority.js')
  resolveStoreModules(require('..\\store\\common\\jobType.js'), 'common/jobType.js')
  resolveStoreModules(require('..\\store\\common\\location.js'), 'common/location.js')
  resolveStoreModules(require('..\\store\\common\\notification.js'), 'common/notification.js')
  resolveStoreModules(require('..\\store\\common\\report-content.js'), 'common/report-content.js')
  resolveStoreModules(require('..\\store\\common\\salesTax.js'), 'common/salesTax.js')
  resolveStoreModules(require('..\\store\\common\\signalr.js'), 'common/signalr.js')
  resolveStoreModules(require('..\\store\\common\\sms.js'), 'common/sms.js')
  resolveStoreModules(require('..\\store\\common\\stores.js'), 'common/stores.js')
  resolveStoreModules(require('..\\store\\custom-orders\\custom-order-items.js'), 'custom-orders/custom-order-items.js')
  resolveStoreModules(require('..\\store\\customer-credits\\customerCredits.js'), 'customer-credits/customerCredits.js')
  resolveStoreModules(require('..\\store\\dashboard\\dashboard.js'), 'dashboard/dashboard.js')
  resolveStoreModules(require('..\\store\\export\\export.js'), 'export/export.js')
  resolveStoreModules(require('..\\store\\integrations\\ipospay.js'), 'integrations/ipospay.js')
  resolveStoreModules(require('..\\store\\integrations\\nmi.js'), 'integrations/nmi.js')
  resolveStoreModules(require('..\\store\\integrations\\square.js'), 'integrations/square.js')
  resolveStoreModules(require('..\\store\\invoices\\invoices.js'), 'invoices/invoices.js')
  resolveStoreModules(require('..\\store\\new-sale\\payments.js'), 'new-sale/payments.js')
  resolveStoreModules(require('..\\store\\orders\\layaway-orders.js'), 'orders/layaway-orders.js')
  resolveStoreModules(require('..\\store\\orders\\orders.js'), 'orders/orders.js')
  resolveStoreModules(require('..\\store\\orders\\sales-commissions.js'), 'orders/sales-commissions.js')
  resolveStoreModules(require('..\\store\\orders\\sales-orders.js'), 'orders/sales-orders.js')
  resolveStoreModules(require('..\\store\\orders\\shipping-methods.js'), 'orders/shipping-methods.js')
  resolveStoreModules(require('..\\store\\outgoing-consignments\\outgoing-consignments.js'), 'outgoing-consignments/outgoing-consignments.js')
  resolveStoreModules(require('..\\store\\payments\\payment.js'), 'payments/payment.js')
  resolveStoreModules(require('..\\store\\repairs\\repairs.js'), 'repairs/repairs.js')
  resolveStoreModules(require('..\\store\\reports\\printedReports.js'), 'reports/printedReports.js')
  resolveStoreModules(require('..\\store\\reports\\reports.js'), 'reports/reports.js')
  resolveStoreModules(require('..\\store\\trade-in\\trade-in.js'), 'trade-in/trade-in.js')
  resolveStoreModules(require('..\\store\\voucher\\voucher.js'), 'voucher/voucher.js')
  resolveStoreModules(require('..\\store\\register\\transactions\\transactions.js'), 'register/transactions/transactions.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
